import ExcelJS from 'exceljs/dist/exceljs';
import {saveAs} from 'file-saver';
import {forEach} from 'lodash';
import {getDateAndHourToExport} from './getDateAndHourToExport';

export const generateExcelWithTopDetails = (userDateFormat, userTimezone, labels, originalData, setIsExporting) => {
	var workbook = new ExcelJS.Workbook();
	var worksheet = workbook.addWorksheet(originalData.worksheetName);
	worksheet.columns = originalData.columns;
	worksheet.spliceRows(1, 1, []);
	worksheet.getCell('A1').value = labels.projectInfo;
	worksheet.getCell('B1').value = originalData.projectName;
	worksheet.getCell('A2').value = labels.exportDate;
	worksheet.getCell('B2').value = getDateAndHourToExport(userDateFormat, userTimezone);
	worksheet.spliceRows(0, 1, []);
	worksheet.getRow(4).values = originalData.columns.map((column) => column.header);

	forEach(originalData.data, (dataItem) => {
		worksheet.addRow(dataItem);
	});
	worksheet.getRow(4).font = {bold: true};

	workbook.xlsx
		.writeBuffer()
		.then((buffer) => {
			saveAs(new Blob([buffer]), originalData.fileName + '.xlsx');
		})
		.catch((err) => console.log('Error writing excel export', err))
		.finally(() => {
			setIsExporting(false);
		});
};
